/*
 * IcKommiAppQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-02 in huWaWi3 33.3.3
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag';

import { KOMMI_FRAGMENT } from '../fragments';

export const KOMMI_LIST_QUERY = gql`
  query KommiAuftraege($cursor: String) {
    nodes: hwKommiAuftrag2Pages(
      after: $cursor
      sort: { order: [ASC, DESC], fields: [status, updated_at] }
      filter: { status: { lt: "500lieferschein_erzeugt" } }
    ) {
      edges {
        cursor
        node {
          ...kommiAuftragFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${KOMMI_FRAGMENT}
`;
export const KOMMI_QUERY = gql`
  query KommiAuftrag($nr: ID!) {
    entity: hwKommiAuftrag2(designator: $nr) {
      ...kommiAuftragFragment
      positionen {
        id
        designator
        komminr
        posnr
        posnr_auftrag

        artnr

        menge_verlangt
        menge_geliefert
        charge_geliefert

        created_at
        updated_at
      }
    }
  }
  ${KOMMI_FRAGMENT}
`;

export const KOMMIAUDIT_QUERY = gql`
  query KommiAudit($nr: ID!) {
    entity: hwKommiAuftrag2(designator: $nr) {
      id
      nodes: auditLog {
        id
        designator
        level
        object_name
        message
        src_file
        src_func
        src_line
        gae_version
        gae_service
        created_by2
        created_at
        updated_at
      }
    }
  }
`;
